import React, { useState, useEffect, useCallback } from "react";
import { AlertCircle } from "lucide-react";
import styles from "../WalletConnector.module.css";

export default function ConnectionError({ wallet, onReturnHome }) {
  const [countdown, setCountdown] = useState(5);
  const [progress, setProgress] = useState(100);

  // Wrap onReturnHome in useCallback to prevent unnecessary re-renders
  const handleReturnHome = useCallback(() => {
    onReturnHome();
  }, [onReturnHome]);

  useEffect(() => {
    // Add a small delay to ensure component is fully mounted
    const initialDelay = setTimeout(() => {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            // Use setTimeout to defer the state update to the next tick
            setTimeout(() => {
              handleReturnHome();
            }, 0);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      const progressTimer = setInterval(() => {
        setProgress((prev) => {
          if (prev <= 0) {
            clearInterval(progressTimer);
            return 0;
          }
          return prev - 100 / 5; // Decrease over 5 seconds
        });
      }, 1000);

      // Cleanup function
      return () => {
        clearInterval(timer);
        clearInterval(progressTimer);
      };
    }, 100); // Small delay to ensure component is mounted

    // Cleanup the initial delay if component unmounts
    return () => {
      clearTimeout(initialDelay);
    };
  }, [handleReturnHome]);

  return (
    <div className={styles.errorContainer}>
      <div>
        <div className={styles.errorLogo}>
          <AlertCircle size={48} />
        </div>

        <h2 className={styles.errorTitle}>Connection Error</h2>

        <p className={styles.errorMessages}>
          We encountered an issue while connecting your{" "}
          {wallet?.name || "MetaMask"} wallet. Please try again later.
        </p>

        <div className={styles.progressContainer}>
          <div
            className={styles.progressBar}
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <p className={styles.countdownText}>
          Redirecting to home page in {countdown} seconds...
        </p>

        <button className={styles.returnButton} onClick={handleReturnHome}>
          Return to Home Page
        </button>
      </div>
    </div>
  );
}
